import {
  useLocation,
  useNavigate,
  Outlet,
  createBrowserRouter,
  RouterProvider,
  useNavigation,
} from 'react-router-dom';
import Home from './page/home';
import SetMenuList from './page/setmenulist';
import { CartProvider } from './context/cartContext';
import NotFound from './page/NotFound';
import MenusDetail from './page/menusdetail';
import OrderSet from './page/orderset';
import Cart from './page/cart';
import Checkout from './page/checkout';
import SuccessPage from './page/success-page';
import FailPage from './page/fail-page';
import React from 'react';
import { campaignLoader } from './Loader/compaignLoader';
import { Heading } from './component/Heading';
import Spinner from 'react-bootstrap/Spinner';

function FullPageSpinner() {
  return (
    <div
      style={{
        minHeight: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

function PaymentRedirectListener() {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const pathname = window.location.pathname.toLowerCase();
    const search = window.location.search || "";

    if (pathname !== "/payment/success" && pathname !== "/payment/failed")
      return;

    const company = sessionStorage.getItem("company");
    if (!company) {
      console.warn("No company found in sessionStorage, redirecting to home");
      navigate("/", { replace: true });
      return;
    }

    if (pathname === "/payment/success") {
      navigate(`${company}/success-page${search}`, { replace: true });
      return;
    }

    if (pathname === "/payment/failed") {
      navigate(`${company}/fail-page`, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function RootLayout() {
  const navigation = useNavigation();

  // show spinner while route loaders (including campaignLoader) are running
  const isLoading = navigation.state === 'loading';

  return (
    <>
      <PaymentRedirectListener />
      <Heading />
      {isLoading ? <FullPageSpinner /> : <Outlet />}
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    hydrateFallbackElement: <FullPageSpinner />,
    children: [
      {
        id: "company-root",
        path: "/:company",
        loader: campaignLoader,
        element: (
          <Outlet />
        ),
        children: [
          { index: true, element: <Home /> },
          { path: "setmenulist", element: <SetMenuList /> },
          { path: "menusdetail", element: <MenusDetail /> },
          { path: "orderset", element: <OrderSet /> },
          { path: "cart", element: <Cart /> },
          { path: "checkout", element: <Checkout /> },
          { path: "success-page", element: <SuccessPage /> },
          { path: "fail-page", element: <FailPage /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

function App() {
  return (
    <CartProvider>
      <RouterProvider router={router} fallbackElement={<FullPageSpinner />} />
    </CartProvider>
  );
}

export default App;